import { Injectable } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Brand } from '../data/enum/brand';
import { Parameter, ParameterCode } from '../data/type/parameter';

@Injectable({
  providedIn: 'root',
})
export class ParameterService {
  private _params: Params;

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params: Params) => {
      this._params = params;
    });
  }

  public showCompareButton() {
    return this.getParam(Parameter['disable-compare']) !== 'true';
  }

  public showBuyButton() {
    const customCTAHref = this.getParam(Parameter['custom-cta-href']);
    const customCTALabel = this.getParam(Parameter['custom-cta-label']);

    return customCTAHref && customCTALabel;
  }

  public isHisenseBrand() {
    return this.getParam(Parameter.brand) === Brand.hisense;
  }

  public isAbstractVersion() {
    return !!Brand[this.getParam(Parameter.brand)];
  }

  public getParam(key: ParameterCode) {
    return this._params[key];
  }

  public getParams() {
    return this._params;
  }
}
